/**
 * Milanote's birthday.
 */
export const MILANOTE_BIRTHDAY_DATE = new Date(2016, 1, 29, 13, 24, 56);

/**
 * Returns Milanote's birthday as a short day/month or month/day label.
 */
export const getShortMilanoteBirthdayLabel = (locale: string): string => {
    const dateParts = new Intl.DateTimeFormat(locale, { day: 'numeric', month: 'numeric' }).formatToParts(
        MILANOTE_BIRTHDAY_DATE,
    );
    const monthIndex = dateParts.findIndex((part) => part.type === 'month');
    const dayIndex = dateParts.findIndex((part) => part.type === 'day');

    const day = String(MILANOTE_BIRTHDAY_DATE.getDate());
    const month = String(MILANOTE_BIRTHDAY_DATE.getMonth() + 1);

    return monthIndex < dayIndex ? `${month}/${day}` : `${day}/${month}`;
};
